 <!--==========================
      Portfolio Section
    ============================-->
    <section id="why-us" class="clearfix">
      <div class="container">

        <header class="section-header">
          <h1 class="section-title" style="text-align: center;">Our Products</h1>
        </header>

        <div class="row row-eq-height justify-content-center">

            <div class="col-lg-4 mb-4">
              <div class="card wow bounceInUp">
                <div class="card-body">
                  <h5 class="card-title">POS Software</h5>
                  <p class="card-text">Complete solution for retail business  that's easy to use. All the modern features you need for retail business.</p>
                  <a [routerLink]="['/retail-pos-system']" class="readmore">Read more </a>
                </div>
              </div>
            </div>
  
            <div class="col-lg-4 mb-4">
              <div class="card wow bounceInUp">
                <div class="card-body">
                  <h5 class="card-title">Lottery Inventory Software</h5>
                  <p class="card-text">Lottery sales and reconciliation solution for Lottery Sellers to track and mantain the Lottery Inventory.</p>
                    <a fragment="lottery-management-software" [routerLink]="['/lottery-management-software']" class="readmore">Read more </a>
                </div>
              </div>
            </div>
  
            <div class="col-lg-4 mb-4">
              <div class="card wow bounceInUp">
                <div class="card-body">
                  <h5 class="card-title">Retail Banking Software</h5>
                  <p class="card-text">Retail banking solution for financial Institutions.</p>
                    <a fragment="Retail-Banking-Software" [routerLink]="['/banking']"  class="readmore" >Read more </a>
                </div>
              </div>
            </div>

            <div class="col-lg-4 mb-4">
                <div class="card wow bounceInUp">
                  <div class="card-body">
                    <h5 class="card-title">Account Payable Software</h5>
                    <p class="card-text">Electronic invoice approval system for paperless office. </p>
                      <a fragment="Account-Payable-Software" [routerLink]="['/account-payable-software']" class="readmore">Read more </a>
                  </div>
                </div>
              </div>
    
              <div class="col-lg-4 mb-4">
                  <div class="card wow bounceInUp">
                    <div class="card-body">
                      <h5 class="card-title">Utility billing Software</h5>
                      <p class="card-text">We have our own in-house talented team with great skills </p>
                        <a fragment="Utility-Billing-Software" [routerLink]="['/utility-billing']" class="readmore">Read more </a>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 mb-4">
                    <div class="card wow bounceInUp">
                      <div class="card-body">
                        <h5 class="card-title">Service Support Software</h5>
                        <p class="card-text">We have our own in-house talented team with great skills</p>
                          <a fragment="Service-Support-Software" [routerLink]="['/service-support']" class="readmore">Read more </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-4 mb-4">
                      <div class="card wow bounceInUp">
                        <div class="card-body">
                          <h5 class="card-title">Inventory Management Software</h5>
                          <p class="card-text">We have our own in-house talented team with great skills </p>
                            <a fragment="Inventory-Management-Software" [routerLink]="['/inventory-management']" class="readmore">Read more </a>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-4 mb-4">
                        <div class="card wow bounceInUp">
                          <div class="card-body">
                            <h5 class="card-title">Marketing Management Software</h5>
                            <p class="card-text">We have our own in-house talented team with great skills </p>
                              <a fragment="Marketing-Management-Software" [routerLink]="['/marketing-management']" class="readmore">Read more </a>
                          </div>
                        </div>
                      </div>
          </div>

      </div>
    </section><!-- #portfolio -->